<template>
  <div id="senior-member-region-edit">
    <v-overlay :value="UpdateFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card
      class="rounded-xl elevation-4 border-0"
      style="background-color: #ffffff; overflow: hidden"
    >
      <v-form
        ref="form1"
        v-model="valid1"
        lazy-validation
        v-on:submit.prevent="confirmAlert"
      >
        <!-- Header -->
        <v-card-title
          class="px-6 py-4 d-flex justify-space-between align-center"
          style="background-color: #3a67b1"
        >
          <div class="d-flex align-center">
            <v-icon color="#EDBE38" class="mr-3" size="28"
              >mdi-map-marker</v-icon
            >
            <span class="text-h6 font-weight-bold" style="color: #ffffff"
              >JAC Member Regional Bulk Update</span
            >
          </div>
          <v-btn icon @click="closePrompt" class="ma-0">
            <v-icon color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="d-flex justify-content-center mb-3" v-if="UpdateFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>

          <!-- Form Fields -->
          <v-container class="pa-0">
            <h5
              class="mb-4 font-weight-bold"
              style="
                color: #3a67b1;
                font-size: 18px;
                border-bottom: 2px solid #edbe38;
                display: inline-block;
                padding-bottom: 4px;
              "
            >
              Change Regional Details
            </h5>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="4">
                <div
                  class="mb-2"
                  style="color: #0a0f29; font-weight: 600; font-size: 15px"
                >
                  Regional <span style="color: #0097d7">*</span>
                </div>
                <v-autocomplete
                  :items="RegionCodeOptions"
                  :rules="RegionCodeRules"
                  :loading="RegionCodeOptionsLoading"
                  item-text="text"
                  item-value="value"
                  v-model="RegionCode"
                  dense
                  clearable
                  required
                  outlined
                  background-color="#FFFFFF"
                  color="#0097D7"
                  class="rounded-lg"
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Footer -->
        <v-divider style="border-color: rgba(65, 64, 66, 0.1)"></v-divider>
        <v-card-actions class="pa-6 pt-4 d-flex justify-end">
          <v-btn
            :disabled="RegionCode === ''"
            @click.prevent="confirmAlert"
            :loading="UpdateFlag"
            elevation="2"
            color="#56BDA3"
            class="rounded-lg font-weight-bold px-8"
            style="
              color: #ffffff;
              text-transform: none;
              height: 44px;
              letter-spacing: 0.5px;
            "
          >
            <v-icon left size="20" color="#FFFFFF"
              >mdi-check-circle-outline</v-icon
            >
            Update
          </v-btn>
          <v-btn
            @click="closePrompt"
            elevation="0"
            outlined
            class="rounded-lg mr-3 font-weight-bold px-6"
            style="
              color: #414042;
              border-color: #414042;
              text-transform: none;
              height: 44px;
            "
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  props: {
    bulkUpdateRegionPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      type: Object,
      required: true,
    },
    selectedRecords: {
      type: Array,
      required: true,
    },
    listZoneCode: {
      required: false,
      default: "",
    },
  },
  data() {
    return {
      valid1: true,
      ZoneCode: "",
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,
      RegionCodeRules: [(v) => !!v || "Regional is required"],
      UpdateFlag: false,
    };
  },
  watch: {
    RegionCodeOptions: function () {
      this.RegionCodeOptionsLoading = false;
    },
  },
  beforeMount() {
    this.initializeBulkRegion();
  },
  methods: {
    initializeBulkRegion() {
      this.ZoneCode = this.listZoneCode;

      if (this.ZoneCode) {
        this.getRegionOptions(true);
      }
    },
    getRegionOptions(isInitialLoad = false) {
      console.log("getRegionOptions called for Zone:", this.ZoneCode);
      this.RegionCodeOptionsLoading = true;

      if (isInitialLoad === true && this.recordData.RegionId) {
        this.RegionCode = Number(this.recordData.RegionId);
      } else {
        this.RegionCode = "";
      }
      var selectbox2_source = "RegionCode";
      var selectbox2_destination = "RegionCodeOptions";
      var selectbox2_url = "api/jac-region/options";
      var selectbox2_conditions_array = {
        UserInterface: 1,
        Zone: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox2_source,
        selectbox2_destination,
        selectbox2_conditions_array,
        selectbox2_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#56BDA3",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#414042",
        }).then((result) => {
          if (result.isConfirmed) {
            this.RegionUpdate();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      }
    },
    RegionUpdate() {
      var validate1 = this.$refs.form1.validate();
      if (!validate1) return;

      this.UpdateFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/senior-members/region-bulk-update";

      var upload = {
        UserInterface: 1,
        Zone: this.ZoneCode,
        Region: this.RegionCode,
        SelectedArray: this.selectedRecords,
        Order: this.recordData.SmOrderId,
      };

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.UpdateFlag = false;
          var output = response.data.output;
          var flag = response.data.flag;

          if (flag == 1) {
            thisIns.sweetAlert("success", output, false);
            thisIns.$emit("hideBulkUpdateRegionRecordPrompt", true);
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          thisIns.UpdateFlag = false;
          thisIns.sweetAlert("error", error, false);
        });
    },
    closePrompt() {
      this.$emit("hideBulkUpdateRegionRecordPrompt", false);
    },
  },
};
</script>

<style scoped></style>
